import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps';
import TableComponent from '../../../components/table/TableOps';

class EtiquetaLogs extends TableComponent {

   componentDidMount() {
      this.tableConfig(
         { dataUrl: `etiqueta/logs?id_etiqueta=${this.props.id_etiqueta}`, deleteUrl: '', deleteField: '', modUrl: '' },
         TableOp.Table('Historial Etiqueta', [
            { label: 'Folio', id: 'folio' },
            { label: 'Estatus', id: 'status' },
            { label: 'Usuario', id: 'user' },
            { label: 'Sucursal', id: 'sucursal' },
            { label: 'Embarque', id: 'id_embarque' },
            { label: 'Fecha y Hora', id: 'createdAt' }
         ], []))
      this.table();
   }
   
   render() {

      return (
         <div>
            <div>
               <this.TableRender />
            </div>
         </div>
      )
   }
}

export default withRouter(EtiquetaLogs)